import { useRouter } from 'next/navigation';
import NProgress from 'nprogress';

export const useNavigationWithLoading = () => {
	const router = useRouter();

	const navigateWithLoading = (path: string, delay: number = 100) => {
		// Start the loading indicator
		NProgress.start();

		// Add a small delay to show the loader
		setTimeout(() => {
			router.push(path);
		}, delay);
	};

	return { navigateWithLoading };
};

// Utility function for direct navigation with loading
export const navigateWithLoading = (path: string, delay: number = 100) => {
	NProgress.start();

	setTimeout(() => {
		window.location.href = path;
	}, delay);
};
